import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getTemplates } from "./actions.js";

export const mediaLiveOutputTemplateEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity._id,
});

const initialState = mediaLiveOutputTemplateEntityAdapter.getInitialState({
  count: 0,
});

export const mediaLiveOutputTemplateSlice = createSlice({
  name: "mediaLiveOutputTemplate",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTemplates.fulfilled, (state, action) => {
      if (action.payload.success) {
        mediaLiveOutputTemplateEntityAdapter.setAll(state, action.payload.data);
        state.count = action.payload.totalTemplates;
      }
    });
  },
});

export default mediaLiveOutputTemplateSlice.reducer;
